import axios from '@/configs/Axios'

const courses = [
    {
        uid: '1',
        type: 'course'
    },
    {
        uid: '2',
        type: 'course'
    },
    {
        uid: '3',
        type: 'course'
    },
    {
        uid: '4',
        type: 'course'
    },
    {
        uid: '5',
        type: 'course'
    }
]

function setWithExpiry(key, value, ttl, userId) {
    const now = new Date()

    const item = {
        value: value,
        uid: userId,
        expiry: now.getTime() + ttl
    }
    localStorage.setItem(key, JSON.stringify(item))
}

const payloadParams = (payload) => {
    if (payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?' + reqData
    } else return ''
}

const state = () => ({
    disciplines: [],
    createdData: {},
    emc: [],
    emcTeacher: [],
    formSetting: {},
    filters: {},
    oldFilters: {},
    oldFiles: [],
    activeTab: Number(localStorage.getItem('emc_active_tab')),
    infiniteStatus: true,
    infiniteStatus2: true,
    page: 0,
    page2: 0
})

const getters = {
    getDisciplines: state => state.disciplines,
    getEmc: state => state.emc,
    getEmcTeacher: state => state.emcTeacher,
    getEmcByUid: state => key => {
        if (state.activeTab === 0) return state.emc.find(item => item.uid === key)
        else return state.emcTeacher.find(item => item.uid === key)
    },
    getFilters: state => state.filters,
    getCreatedData: state => state.createdData,
    getOldFiles: state => state.oldFiles,
    getActiveTab: state => state.activeTab
}

const mutations = {
    SET_PAGE(state, value) {
        state.page = value
    },
    SET_PAGE2(state, value) {
        state.page2 = value
    },
    SET_INF_STATUS(state, value) {
        state.infiniteStatus = value
    },
    SET_INF_STATUS2(state, value) {
        state.infiniteStatus2 = value
    },
    SET_OLD_FILES(state, value) {
        state.oldFiles = value
    },
    PUSH_EMC(state, value) {
        state.emc = state.emc.concat(value);
    },
    PUSH_EMC_TEACHER(state, value) {
        state.emcTeacher = state.emcTeacher.concat(value);
    },
    CLEAR_DISCIPLINES(state) {
        state.disciplines = []
    },
    CLEAR_EMC(state) {
        state.emc = []
    },
    CLEAR_EMC_TEACHER(state) {
        state.emcTeacher = []
    },
    SET_CREATED_DATA(state, value) {
        state.createdData = value
    },
    SET_FORM_SETTING(state, value) {
        state.formSetting = value
    },
    SET_ACTIVE_TAB(state, value) {
        state.activeTab = value
    },
    SET_FILTERS(state, value) {
        state.filters = value
    },
    SET_OLD_FILTERS(state, value) {
        state.oldFilters = value
    },
    SET_POST_DATA(state, value) {
        state.emc = state.emc.concat(value.data)
    },
    UPDATE_EMC(state, value) {

        const idx = state.emc.findIndex(el => el.uid === value.uid)
        state.emc[idx] = value
    },
    deleteEmcDinData(state, value) {
        state.emc = state.emc.filter(el => el.uid !== value)
    }
}

const actions = {
    fetchAllFiles({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(`/emc/emc/emc_old_files`)
                .then(({ data }) => {
                    commit('SET_OLD_FILES', data)
                    resolve(data)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchEmc({ commit }, payload) {
        return new Promise((resolve, reject) => {

            const query = {
                page: payload.page,
                ...payload.route.query
            }

            axios.get(`/emc/emc/emc_list/${ payloadParams(query) }`)
                .then(({ data }) => {
                    if (typeof data === 'object') {
                        commit('PUSH_EMC', data.results)
                        resolve(data)
                    } else resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchEmcTeacher({ commit }, payload) {
        return new Promise((resolve, reject) => {

            const query = {
                page: payload.page,
                ...payload.route.query
            }

            axios.get(`/emc/emc/teacher_emc_list/${ payloadParams(query) }`)
                .then(({ data }) => {
                    if (typeof data === 'object') {
                        commit('PUSH_EMC_TEACHER', data.results)
                        resolve(data)
                    } else resolve(false)

                })
                .catch((error) => { reject(error) })
        })
    },
    fetchDisciplinesFilters({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get(`/emc/emc/filter_for_student/`)
                .then(({ data }) => {
                    if (data) {
                        let filters = data
                        filters['courses'] = courses
                        commit('SET_FILTERS', filters)
                        resolve(filters)
                    } else resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchFormData({ commit, state, dispatch }) {
        return new Promise((resolve, reject) => {
            dispatch('fetchFormSetting')
            if (!Object.keys(state.createdData).length) {
                axios.get(`/emc/emc/create_emc`)
                    .then(({ data }) => {
                        commit('SET_CREATED_DATA', data)
                        resolve(data)
                    })
                    .catch((error) => { reject(error) })
            } else
                resolve(state.createdData)
        })
    },
    fetchFormSetting({ commit, rootState }) {
        return new Promise((resolve, reject) => {
            let dataStorage = JSON.parse(localStorage.getItem('form_setting'));
            const now = new Date(),
                userId = rootState.user.user.profileId;

            if (dataStorage && dataStorage.uid !== userId) {
                localStorage.removeItem('form_setting')
                dataStorage = false
            }

            if (!dataStorage || now.getTime() >= dataStorage.expiry) {
                axios.get(`/common/settings/`)
                    .then(({ data }) => {
                        const time = now.getTime() + (1000 * 60 * 60 * 24)
                        setWithExpiry('form_setting', data[0], time, userId)

                        commit('SET_FORM_SETTING', data[0])
                        resolve(data[0])
                    })
                    .catch((error) => { reject(error) })
            } else {
                commit('SET_FORM_SETTING', dataStorage.value)
                resolve(dataStorage.value)
            }
        })
    },

    postEmc({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/emc/create`, payload)
                .then((response) => {
                    commit("SET_POST_DATA", response)
                    resolve(response)

                })
                .catch((error) => { reject(error) })
        })
    },

    update({ commit }, payload) {
        return new Promise((resolve, reject) => {

            axios.put(`/emc/update/${ payload.uid }/`, payload)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
